import { useEffect, useState } from 'react';

export interface OAuthRedirectError {
  code: string | null;
  description: string | null;
}

/** Reads both Supabase callback formats and removes query/hash credentials. */
export function consumeOAuthRedirectError(): OAuthRedirectError | null {
  if (typeof window === 'undefined') return null;
  const search = new URLSearchParams(window.location.search);
  const hash = new URLSearchParams(window.location.hash.replace(/^#/, ''));
  const get = (key: string) => search.get(key) ?? hash.get(key);
  const code = get('error_code') ?? get('error');
  const description = get('error_description');
  if (window.location.search || window.location.hash) {
    window.history.replaceState(null, document.title, window.location.pathname);
  }
  if (!code && !description) return null;
  return { code, description };
}

export function oauthRedirectMessage(error: OAuthRedirectError): string {
  if (error.code === 'identity_already_exists') {
    return 'Dieses Google-Konto ist bereits mit einem anderen Account verknüpft. Melde dich stattdessen direkt mit diesem Google-Konto an, oder verknüpfe ein anderes.';
  }
  return error.description ? `Google-Anmeldung fehlgeschlagen: ${error.description}` : 'Google-Anmeldung fehlgeschlagen. Bitte versuche es erneut.';
}

export function OAuthRedirectNotice() {
  const [error, setError] = useState<OAuthRedirectError | null>(null);
  useEffect(() => setError(consumeOAuthRedirectError()), []);
  if (!error) return null;
  return <p role="alert" className="fixed inset-x-4 top-4 z-50 mx-auto max-w-xl rounded-control border border-danger/40 bg-danger/10 p-3 text-center text-xs leading-relaxed text-danger-bright shadow-lg">{oauthRedirectMessage(error)}</p>;
}
